// semeia-disable-reexport
import { bioExamResultCodeFromOrderCode } from "parog-web/config/bio-exam-result-from-order";
import type { ExpectedDosage } from "parog-web/models/bio-exam-expected-dosage-changed-journal-event";
import type Patient from "parog-web/models/patient";

interface DatedExpectedDosage {
  min: number;
  max: number;
  date: Date;
}

export function getNewExpectedDosages(patient: Patient) {
  const lastDosageExpected = patient.bioExamExpectedDosageChangedJournalEvent;

  if (lastDosageExpected == undefined) return undefined;

  const newDosages = (
    lastDosageExpected.expectedDosages as ExpectedDosage[]
  ).map(dosage => {
    return bioExamResultCodeFromOrderCode[dosage.code]
      ? {
          code: bioExamResultCodeFromOrderCode[dosage.code],
          min: dosage.min,
          max: dosage.max
        }
      : dosage;
  });

  const expectedDosages = {};

  for (const expectedDosage of newDosages) {
    // TODO: this should contain references to BioExamResultCode, not another kind of object.
    expectedDosages[expectedDosage.code] = {
      code: expectedDosage.code,
      minReferenceValue: expectedDosage.min,
      maxReferenceValue: expectedDosage.max
    };
  }

  return expectedDosages;
}

export function getExpectedDosagesByCode(patient: Patient) {
  const expectedDosageByCode = new Map<string, DatedExpectedDosage[]>();

  const expectedDosageJes = patient.bioExamExpectedDosageChangedJournalEvents;

  expectedDosageJes.forEach(je => {
    (je.expectedDosages as ExpectedDosage[]).forEach(expectedDosage => {
      const code = bioExamResultCodeFromOrderCode[expectedDosage.code];
      if (!expectedDosageByCode.has(code)) {
        expectedDosageByCode.set(code, []);
      }

      (expectedDosageByCode.get(code) as DatedExpectedDosage[]).push({
        min: expectedDosage.min,
        max: expectedDosage.max,
        date: je.occurredAt
      });
    });
  });

  return expectedDosageByCode;
}
